import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcKakao = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		y: .289612,
		width: 18,
		height: 18.3333,
		fill: "url(#pattern0_446_13230)"
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("pattern", {
		id: "pattern0_446_13230",
		patternContentUnits: "objectBoundingBox",
		width: 1,
		height: 1,
		children: /* @__PURE__ */ _jsx("use", {
			xlinkHref: "#image0_446_13230",
			transform: "scale(0.0185185 0.0181818)"
		})
	}), /* @__PURE__ */ _jsx("image", {
		id: "image0_446_13230",
		width: 54,
		height: 55,
		xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA3CAYAAABHGbl4AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAORSURBVHgB7ZpbiE1RHMY/BhHGFBnFaORFpjQyowZh8CJGecKDByUPSB48eKEoubxIEUrJg1tCEYVk0tDkUm7j1mAal4YxLoNxn/F9/ntOxzFnzt7n7Dnn7N189WvO2WfN6Xx7rf/aa/3/C+hWt7rVleoB/5RD8skwUkgKyHDnWv+Ytl/Ia/KS1JNnzvs35Dd8UKrG+pIxZDKZAjOU71z3ohaYsTpymVSTR+QbklSyxkaSmWQeKSID4K8+kxpyilyE9aoneTWWR5aQRWQE0qMX5DDZTz64/Se3xgaRhWQpLG4yIcXjPnKEfEzU2I2xCWQ9KYG/k00yaiM3yEZys7OGOZ18JhOKoV1kNDJvCs5v0IiZDRuij+M1jGesF1lMtpCByD71I7NgMadJpjW2QUfGepN1ZI3zOlulmz+D5JIqxJiLNaauXk2Wk57Ifun3FsNirzr6g1hjFWQD7G4ERTJXSmoRFXPRE4KC8gwZimBKy7E5sMfCPz2miaIEwZXWo+oUdU4kjjROKxB8zYV5iRhbhmDFVTzJg7z8jbHB5Brs2RAGaUdQqh4rR3hMSdoylcvYJIRPZTI2FuFTkYyla1+VThXIWC7Cp4Ey1orwqU3GmhE+NcvYc4RP9TJ2D+FTjYxVIXy6ImNXYZnZsEheqmSsiZxDeHSeNLWv7neS7wi+fsC8RLYtD8kxBF/y8EAvolMDQ8hZBHeJpTyjUgONehOdGlDFo9b5MGibzq9kJbnffiE2S1XnNFJJKAjpN+kn2URORl/sKGF6y/k7Edlv7hfZTvbAcosRdWRMDa7Dek75umzNBit0tpHdcJnihtNQVQ2VUJWS87uwl6oayFpyCHF2JzkJvkDl0kpYBVNkemiqPl1JVsFWTHHltjSkZM98soKMQmakGXsvbJJoSdTYa81rASxY0yUNsyfkKDkOK8C7ktfnVTHSo7fkLjkBO0XQCI/yYky9OxX+S7OwasqaELQcukTukKew6TwpeTFW6OBWWlRr16BthBJGfWCTjzK1Ou6gXnkFWxQ0OLyHT/JiTL3lNiZVp9pKLiCFu56KvBib5qKNHuoK9B3wEOhdIbfGNIwSpcK1AN0Me874ch4qFbk1Nh7xE6uKoYOwYxOeZ6+ukltj8YbhbVgv/Ve1z7TcGpse8/4TOQBbVb9DQKXCoE6faWpW4fo0KUN2nNRJSTpuVAebHHSoJQ8hUfuKYxwC1Et/APkPqj305KbSAAAAAElFTkSuQmCC"
	})] })]
});
export default SvgIcKakao;
